<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="address-edit-box">
    <s-header :name="'任务上报'"></s-header>
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field name="radio" label="事项申报" :rules="[{ required: true, message: '需要事项申报' }]">
          <template #input>
            <van-radio-group v-model="checked">
              <van-radio v-for="(item, index) in getTaskEventType" :key="index" :name="item.index" class="radio-gap">{{ item.desc}}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
            v-model="message"
            name="message"
            rows="2"
            autosize
            label="事项说明"
            type="textarea"
            maxlength="100"
            placeholder="（请对事项进行简要说明，字数控制在100字以内）"
            show-word-limit
            :rules="[{ required: true, message: '需要事项说明' }]"
        />

        <van-field name="uploader" label="上传图片" :rules="[{ required: true, message: '需要图片' }]">
          <template #input>
            <van-uploader v-model="picture" multiple :after-read="afterRead"/>
          </template>
        </van-field>
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {onMounted, reactive, toRefs} from 'vue'
import sHeader from '@/components/SimpleHeader'
import {addTask, getTaskList, uploadImg} from '@/service/task'
import {getTaskEventType} from '@/common/js/constants'
import { Toast } from '@vant/compat';
import {useRouter} from "vue-router";


export default {
  methods: {getTaskList},
  components: {
    sHeader
  },
  setup() {
    const router = useRouter()

    const state = reactive({
      checked: '1',
      message: undefined,
      picture: [],
      pictureUrls: [],


    })

    onMounted(async () => {

    })


    const onSubmit = (values) => {
      const {message, radio} = values
      addTask({message, radio, pictureUrls: state.pictureUrls}).then(() => {
        Toast('保存成功')
        router.push({ path: '/my-task' })
      })
    };

    const afterRead = (file, sign) => {
      // 返回图片信息
      console.log(file, sign);
      //以下就要自行书写 -----------------------------
      const ImgUploadFile = (params) => {
        // 要把数据变成file格式
        const formData = new FormData(); // 下面有备注
        formData.append('file', params);
        return uploadImg(formData, {
          headers: {
            // 注意修改请求头file格式
            'Content-Type': 'multipart/form-data',
          },
        });
      };
      ImgUploadFile(file.file).then((res) => {
        // 在这里对接口返回数据做处理
        console.log(res);
        state.pictureUrls.push(res.data)
      });
      //以上就要自行书写 -----------------------------
    }
    return {
      ...toRefs(state),
      getTaskEventType,
      onSubmit,
      afterRead
    }
  }
}
</script>

<style lang="less">
@import '../common/style/mixin';


.radio-gap {
  margin: 5px 0;
}
</style>
